import { defineComponent as e, openBlock as t, createBlock as i, Transition as n, withCtx as s, createElementBlock as p, normalizeClass as a, renderSlot as l, createCommentVNode as r } from "vue";
import { _ as m } from "../../../_plugin-vue_export-helper-dad06003.js";
const d = e({
  name: "VTooltip",
  props: {
    position: {
      validator(o) {
        return ["top", "bottom", "left", "right"].indexOf(o) !== -1;
      }
    },
    showTooltip: {
      type: Boolean,
      default: !1
    }
  }
});
function f(o, c, _, u, w, h) {
  return t(), i(n, {
    name: "bounce-in-" + o.position
  }, {
    default: s(() => [
      o.showTooltip ? (t(), p("div", {
        key: 0,
        class: a(["hobi-tooltip tw-inline-block", [
          o.position === "top" ? "tw-mb-2" : "",
          o.position === "bottom" ? "tw-mt-2" : "",
          o.position === "left" ? "tw-mr-2" : "",
          o.position === "right" ? "tw-ml-2" : ""
        ]])
      }, [
        l(o.$slots, "default", {}, void 0, !0)
      ], 2)) : r("", !0)
    ]),
    _: 3
  }, 8, ["name"]);
}
const T = /* @__PURE__ */ m(d, [["render", f], ["__scopeId", "data-v-041a185f"]]);
export {
  T as default
};
